/* EkDoTee wishlist + share. Wishlist is saved in this browser (no login needed). */
(function () {
  var KEY = 'ekd-wishlist';
  var root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(h) { return read().indexOf(h) > -1; }

  var toastTimer;
  function toast(msg, link) {
    var t = document.getElementById('CartToast');
    if (!t) return;
    t.querySelector('[data-toast-msg]').textContent = msg;
    t.classList.remove('is-error');
    var l = t.querySelector('.toast__link');
    if (l) {
      if (!l.dataset.orig) { l.dataset.orig = l.getAttribute('href'); l.dataset.origText = l.textContent; }
      if (link) { l.setAttribute('href', link.href); l.textContent = link.text; l.hidden = false; }
      else { l.hidden = true; }
    }
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; if (l) { l.setAttribute('href', l.dataset.orig); l.textContent = l.dataset.origText; l.hidden = false; } }, 3500);
  }

  function sync() {
    var list = read();
    document.querySelectorAll('[data-wl-btn]').forEach(function (b) {
      var on = list.indexOf(b.dataset.wlHandle) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on);
      var label = b.querySelector('[data-wl-label]');
      if (label) label.textContent = on ? 'Saved' : 'Save';
    });
    document.querySelectorAll('[data-wl-count]').forEach(function (c) {
      c.textContent = list.length;
      c.hidden = list.length === 0;
    });
  }

  function toggle(btn) {
    var h = btn.dataset.wlHandle;
    var list = read();
    var i = list.indexOf(h);
    if (i > -1) { list.splice(i, 1); write(list); toast('Removed from your wishlist'); }
    else { list.unshift(h); write(list); toast('Saved to your wishlist', { href: root + 'pages/wishlist', text: 'View wishlist' }); }
    btn.classList.remove('pop'); void btn.offsetWidth; btn.classList.add('pop');
    sync();
    document.dispatchEvent(new CustomEvent('wishlist:change'));
  }

  /* ---------- Share ---------- */
  function closeShare() {
    document.querySelectorAll('[data-share].is-open').forEach(function (s) {
      s.classList.remove('is-open');
      var b = s.querySelector('[data-share-btn]'); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (res, rej) {
      var ta = document.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', '');
      ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy') ? res() : rej(); } catch (e) { rej(e); } ta.remove();
    });
  }
  function share(wrap) {
    var url = wrap.dataset.shareUrl || window.location.href.split('?')[0];
    var title = wrap.dataset.shareTitle || document.title;
    var text = wrap.dataset.shareText || title;
    var touch = window.matchMedia('(hover: none)').matches;
    if (navigator.share && touch) {
      navigator.share({ title: title, text: text, url: url }).catch(function () {});
      return;
    }
    var open = wrap.classList.contains('is-open');
    closeShare();
    if (!open) { wrap.classList.add('is-open'); wrap.querySelector('[data-share-btn]').setAttribute('aria-expanded', 'true'); }
  }

  document.addEventListener('click', function (e) {
    var wl = e.target.closest('[data-wl-btn]');
    if (wl) { e.preventDefault(); e.stopPropagation(); toggle(wl); return; }
    var sb = e.target.closest('[data-share-btn]');
    if (sb) { e.preventDefault(); share(sb.closest('[data-share]')); return; }
    var cp = e.target.closest('[data-share-copy]');
    if (cp) {
      e.preventDefault();
      var w = cp.closest('[data-share]');
      copy(w.dataset.shareUrl || window.location.href.split('?')[0])
        .then(function () { toast('Link copied'); })
        .catch(function () { toast('Could not copy the link'); });
      closeShare();
      return;
    }
    if (!e.target.closest('[data-share]')) closeShare();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeShare(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  window.EkdWishlist = { read: read, write: write, has: has, sync: sync };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
